import React, { Component } from 'react';

//styles
import './SectionFour.scss';
import '../../static/videoApi';

class SectionFour extends Component {
    componentDidMount() {
        window.videoObj().initVideo();
    }
    render() {
        return (
            <div id="section4" className="section4-container">
                <div className="desc-container">
                    <div className="star"></div>
                    <div className="title">הבריחה מטהרן</div>
                    <div className="sub-title">אלפי ישראלים חיו באיראן ערב המהפכה. <br/>הם עדיין לא מבינים: "בן לילה הפכנו לשנואים"</div>
                <div id="ynetPlayer_341147" className="video"></div>
                </div>
                <div className="line"></div>

            </div>
        );
    }
}

export default SectionFour;


// WEBPACK FOOTER //
// ./src/Components/SectionFour/SectionFour.js